<div class="page">
    <div class="content">
        <h5>{{ 'RESCAN.TITLE' | translate }}</h5>
        <p>{{ 'RESCAN.ACTION' | translate }}</p>
    </div>
</div>
